export default __webpack_public_path__ + "static/service_sanitation@2x-697f52cdfd70f841d7cd11c7b85fe2e4.jpg";